module.exports = __webpack_public_path__ + "96e9714a5241d9c3468378d057f2a18b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Camps/camps2.jpg
// module id = 1208
// module chunks = 0